import { combineReducers } from 'redux';
import dadesBasiques from './dadesBasiques';
import fotos from './fotos';
import localitzacio from './localitzacio';
import variablesMoments from './variablesMoments';
import metadades from './metadades';
import historicObservadors from './historicObservadors';
import incidencies from './incidencies';

export default combineReducers({
    dadesBasiques,
    fotos,
    localitzacio,
    variablesMoments,
    metadades,
    historicObservadors,
    incidencies
});



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/dades/index.js